var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZhuanyecanzhao(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631288",
    x: 1.625,
    y: 1.625,
    width: 11,
    height: 12.75,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 642",
    d: "M7.9375 3.21875V5.84375H10.375",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 643",
    d: "M6.3125 9.5L6.3125 6.875L3.875 6.875",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631289",
    x: 12.625,
    y: 3.28125,
    width: 2.53125,
    height: 9.4375,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 644",
    d: "M3.6875 11.6875H11.0938",
    stroke: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZhuanyecanzhao);
export default __webpack_public_path__ + "static/media/zhuanyecanzhao.1cdfc76d17f7d2dedd4252e5ba5250d0.svg";
export { ForwardRef as ReactComponent };